<template>
    <span>{{seconds | secondsFormattedAsTimer}}</span>
</template>
<script>
let timer;
export default {
  name: 'AppClockElapsedTime',
  data() {
    return {
        seconds: 0
    };
  },
  methods: {
    start() {
      this.seconds = 0;
      timer = setInterval(() => {
          this.seconds += 1;
        }, 1000);
    },
    reset() {
      clearInterval(timer);
      this.seconds = 0;
    }
  },
  filters: {
    secondsFormattedAsTimer: function (seconds) {
      return new Date(seconds * 1000).toISOString().substring(11, 19);
    }
  }
};
</script>
<style lang="scss">
</style>
